const UiDefualtState = {
  menuOpen: false,
};

export default UiDefualtState;
